import apiClient from "./client";
import {
  startSession,
  getSession,
  autosave,
  submitSession,
  findInProgressSession,
} from "./sessions";
import type { Answer, ExamContent, Session, WritingSubmission } from "@/types";

/**
 * Writing API.
 * Content: GET /writing/tests/{test_id}
 * Sessions use the shared /sessions endpoints with skill="writing".
 *
 * Writing essays are persisted as the `writing` array on submit; for autosave
 * we reuse the answers channel keyed by task id so drafts survive a refresh.
 */

const SKILL = "writing" as const;

export async function getWritingExam(testId: number): Promise<ExamContent> {
  const { data } = await apiClient.get<ExamContent>(
    `/writing/tests/${testId}`
  );
  return data;
}

export const startWriting = (testId: number): Promise<Session> =>
  startSession({ test_id: testId, skill: SKILL });

export const getWritingSession = (sessionId: number): Promise<Session> =>
  getSession(sessionId);

export const findWritingSession = (testId: number): Promise<Session | null> =>
  findInProgressSession(testId, SKILL);

// Drafts are autosaved through the answers channel (question_number = task order).
export const autosaveWriting = (
  sessionId: number,
  drafts: Answer[]
): Promise<Session> => autosave(sessionId, drafts);

export const submitWriting = (
  sessionId: number,
  writing: WritingSubmission[]
): Promise<Session> => submitSession(sessionId, { writing });
